import React from "react";

const SubEventCard = ({
  imageSrc,
  imageAlt,
  title,
  subtitle,
  date,
  time,
  buttonText,
}) => {
  return (
    <div className="event-card sub-event-card">
      {/* Left Image */}
      <div className="event-card-image">
        <img src={imageSrc} alt={imageAlt} />
      </div>

      {/* Right Content */}
      <div className="content" style={{ color: "black" }}>
        <div className="text">
          <h2 className="title">{title}</h2>
          <p className="subtitle" dangerouslySetInnerHTML={{__html: subtitle }}></p>
          {/* <div className="date-time">
            <p className="date">{date}</p>
            <p className="time">{time}</p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default SubEventCard;
